import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SignupEventService {
  private _signUpEvent = new Subject<boolean>();
  signUpEvent$ = this._signUpEvent.asObservable();

  emit(isEnable: boolean): void {
    this._signUpEvent.next(isEnable);
  }
}
